import React from 'react'
import I18n from 'i18n'
import _ from 'lodash'

import { getFirstDataRow, prepareSummaryFields } from '../../../../common/Utils'
import { prepareTrainingLogData } from '../CoachDashboardHelper'
import { activitySummaryToMetric, s2hms, summaryWithUnitsToString } from '../../../../common/Units'
import { COACH_DASHBOARD_COL1_SUMMARY_FIELDS, COACH_DASHBOARD_COL2_SUMMARY_FIELDS, COACH_DASHBOARD_MAIN_SUMMARY_FIELDS, EMPTY_RECORD } from '../../../../common/Constants'
import SummaryTableMultiple from '../SummaryTableMultiple'
import SummaryTable from '../../common/SummaryTable'
import { round } from '../../../../common/Math'
import { readTrainingQuestionnaire } from '../../../../common/utils/QuestionnaireUtils'
import { getTrainingLoad } from '../../../../common/Calculations'
import { translateTrainingType, translateSessionType } from '../../../../training/layout/TrainingSessionsTable'

const TrainingSessionSummary = (props) => {
  const { activity, trainingLog, scheduledTraining, trimp } = props

  const prepareSummaryTableMultiple = (actualSummary = {}, expectedSummary = {}, summaryFields) => {
    const rows = _.reduce(summaryFields, (accum, field) => {
      const summaryRow = {
        label: I18n.t(`components.dashboards.table.${field}`),
        value: actualSummary[field] || EMPTY_RECORD,
        scheduled: expectedSummary[field] || EMPTY_RECORD

      }

      accum.push(summaryRow)
      return accum
    }, [])

    const headers = {
      label: '',
      value: I18n.t('components.dashboards.coach_individual.training.table.actual'),
      scheduled: I18n.t('components.dashboards.coach_individual.training.table.scheduled')
    }
    const fields = ['label', 'value']
    if (!_.isEmpty(expectedSummary)) {
      fields.push('scheduled')
    }

    return {
      fields: fields,
      rows: rows,
      headers: headers
    }
  }

  // Handle scheduledTraining array - get the first item if it's an array
  let currentScheduledTraining = null
  if (scheduledTraining) {
    if (Array.isArray(scheduledTraining) && scheduledTraining.length > 0) {
      currentScheduledTraining = scheduledTraining[0] // Take the first scheduled training
    } else if (!Array.isArray(scheduledTraining)) {
      currentScheduledTraining = scheduledTraining // It's already a single object
    }
  }

  const summaryWithStrings = {}
  if (trainingLog) {
    const trainingLogValues = getFirstDataRow(trainingLog)?.values
    const trainingLogData = readTrainingQuestionnaire(trainingLogValues)
    const trainingLogWithStrings = prepareTrainingLogData(trainingLogData)
    _.merge(summaryWithStrings, trainingLogWithStrings)
  }
  if (activity) {
    const summaryWithUnits = activitySummaryToMetric(activity?.vdo?.summary)
    const activitySummaryWithStrings = summaryWithUnitsToString(summaryWithUnits)
    _.merge(summaryWithStrings, activitySummaryWithStrings)
  }
  if (trimp || trimp === 0) {
    summaryWithStrings.trimp = `${trimp}`
  }

  const expectedSummary = {}
  if (currentScheduledTraining) {
    const {
      expected_rpe: rpe = EMPTY_RECORD,
      expected_duration: duration = EMPTY_RECORD,
      training_type: trainingType,
      session_type: sessionType,
      fun = EMPTY_RECORD // This might not exist in your object, so it will default to EMPTY_RECORD
    } = currentScheduledTraining
    const srpe = round(getTrainingLoad(rpe, duration), 2) || EMPTY_RECORD

    expectedSummary.rpe = `${rpe}`
    expectedSummary.duration = `${s2hms(duration * 60)} ${I18n.t('units.h')}`
    expectedSummary.srpe = `${srpe}`
    expectedSummary.training_type = translateTrainingType(trainingType) || EMPTY_RECORD
    expectedSummary.session_type = translateSessionType(sessionType) || EMPTY_RECORD
    expectedSummary.fun = `${I18n.t(`components.dashboards.questionnaire.fun.${fun}`)}`
  }

  const summaryTableMultipleElems = prepareSummaryTableMultiple(summaryWithStrings, expectedSummary, COACH_DASHBOARD_MAIN_SUMMARY_FIELDS)
  const summaryTableFields1 = prepareSummaryFields(summaryWithStrings, COACH_DASHBOARD_COL1_SUMMARY_FIELDS)
  const summaryTableFields2 = prepareSummaryFields(summaryWithStrings, COACH_DASHBOARD_COL2_SUMMARY_FIELDS)

  const trainingLogAnswers = readTrainingQuestionnaire(getFirstDataRow(trainingLog)?.values)
  const commentsTableField = {
    fields: ['label', 'comments'],
    rows: [{
      label: I18n.t('components.dashboards.coach_individual.training.table.comments'),
      comments: trainingLogAnswers.comments
    }]
  }
  return (
    <div className='row'>
      <div className='col s12'>
        <SummaryTableMultiple {...summaryTableMultipleElems} />
      </div>
      <div className='col s6'>
        <SummaryTable fields={summaryTableFields1} />
      </div>
      <div className='col s6'>
        <SummaryTable fields={summaryTableFields2} />
      </div>
      <div className='col s12'>
        <SummaryTableMultiple {...commentsTableField} />
      </div>
    </div>
  )
}

export default TrainingSessionSummary
